angular.module('unergie.main')
.factory('PaymentService', ($filter, DataAccess, MetaWatcher, ApiUser, AlertManager, AccountService, BoFeaturesService, MS, AdminComments, ErrorCatcher) => {
    const canPlaceProviderPayment = BoFeaturesService.get('canPlaceProviderPayment')
    const providerLabel = BoFeaturesService.get('providerLabel')

    const newPaymentPayload = () => ({
        amount: 0,
        payment_date: moment().toDate(),
        providerInitiative: false,
    })

    const newReimbursementPayload = () => ({
        amount: 0,
        payment_date: moment().toDate(),
    })

    const newPaymentFields = function () {
        if (canPlaceProviderPayment) {
            return {
                amount: {
                    label: 'Montant',
                    type: 'number',
                },
                payment_date: {
                    label: 'Date de paiement',
                    type: 'date',
                },
                providerInitiative: {
                    label: 'Initiative',
                    type: 'select',
                    enum: [
                        { label: 'Client', value: false },
                        { label: `Initiative ${providerLabel} (Envoi de SMS)`, value: true },
                    ],
                },
            }
        }
        return {
            amount: {
                label: 'Montant',
                type: 'number',
            },
            payment_date: {
                label: 'Date de paiement',
                type: 'date',
            },
        }
    }

    const reimbursementFields = () => ({
        amount: {
            label: 'Montant',
            type: 'number',
        },
        payment_date: {
            label: 'Date de paiement',
            type: 'date',
        },
    })

    const paymentMailPayload = () => ({
        amount: 0,
        mode: 'email',
    })

    const paymentMailFields = () => ({
        amount: { label: 'Montant', type: 'number' },
        mode: {
            label: 'Mode d’envoi',
            type: 'select',
            enum: [
                { label: 'E-mail', value: 'email' },
                { label: 'E-mail + SMS', value: 'both' },
            ],
        },
    })

    const logPaymentFields = (extraEnabled) => {
        const fields = _.cloneDeep({
            mode: {
                label: 'Mode de paiement',
                required: true,
                type: 'radio',
                enum: [
                    { label: 'Chèque', value: 'CHECK' },
                    { label: 'Espèces', value: 'CASH' },
                    { label: 'Virement bancaire', value: 'TRANSFER' },
                ],
            },
            amount: { label: 'Montant', type: 'number', required: true },
            payment_date: { label: 'Date du paiement', type: 'datetime', required: true },
            external_ref: { label: 'Référence', type: 'text' },
            sendEnergieCheckReceivedMail: {
                label: 'Envoyer le mail de réception chèque énergie',
                hidden: (payload) => payload.mode !== 'ENERGY_CHECK',
                type: 'checkbox',
            },
            traceFSLpayment: {
                label: 'Ce paiement correspond à une demande de FSL',
                type: 'checkbox',
            },
        })
        if (extraEnabled) {
            fields.mode.enum.push({ label: 'Opération extraordinaire (compta)', value: 'EXTRA' },
                { label: 'Surendettement (compta)', value: 'OVER_INDEBT' },
                { label: 'Op. extra pas de synchro (compta)', value: 'CORRECTION' })
        }
        return fields
    }

    const logPaymentPayload = (contract) => ({
        amount: undefined,
        payment_date: undefined,
        external_ref: '',
        id_contract: contract.id,
        mode: 'CHECK',
        sendEnergieCheckReceivedMail: false,
        traceFSLpayment: false,
    })

    const syncFields = () => ({
        scheme: {
            label: 'Type',
            required: true,
            type: 'radio',
            enum: [
                { label: 'SEPA', value: 'SEPA.DIRECT_DEBIT.CORE' },
                { label: 'CB', value: 'CARD' },
            ],
        },
    })

    const syncPayload = (customer_id) => ({
        scheme: 'SEPA.DIRECT_DEBIT.CORE',
        recursive: true,
        customer_id,
    })


    const prepareLogPaymentPayload = function (payment = {}) {
        payment.payment_date = moment()
        payment.amount = undefined
        payment.external_ref = ''
        payment.mode = 'CHECK'
    }


    const logPayment = function (paymentPayload, refeshing) {
        refeshing.refeshing = true
        const payload = _.omit(angular.copy(paymentPayload), ['sendEnergieCheckReceivedMail', 'traceFSLpayment'])
        payload.payment_date = moment(payload.payment_date).toISOString()
        return DataAccess.traceExternalPayment(
            { sendEnergieCheckReceivedMail: paymentPayload.sendEnergieCheckReceivedMail, traceFSLpayment: paymentPayload.traceFSLpayment },
            payload
        ).$promise.then(() => {
            AlertManager.success('Paiement ajouté')
            if (paymentPayload.traceFSLpayment) {
                MetaWatcher.notif('ACCOUNT_CHANGED')
            }
        }).catch(ErrorCatcher)
        .finally(() => {
            refeshing.refeshing = false
        })
    }

    const syncSlimpay = function (payload, refeshing) {
        refeshing.refeshing = true
        return ApiUser.syncSlimpay(payload, {}).$promise.then(() => {
            AlertManager.success('Synchronisé')
        }).catch(ErrorCatcher)
        .finally(() => {
            refeshing.refeshing = false
        })
    }

    const validatePayment = function (payment, refreshObject) {
        refreshObject[payment.id] = true
        return DataAccess.validateExternalPayment({ id: payment.id }, {}).$promise.then(() => {
            AlertManager.success('Paiement validé')
        }).catch(ErrorCatcher)
        .finally(() => {
            refreshObject[payment.id] = false
        })
    }

    const sendPaymentMail = function (contract, paymentPayload, balance) {
        if (paymentPayload.amount > -balance) {
            return AlertManager.error(`Impossible de générer un paiement supérieur au solde débiteur (${-balance}) €`)
        }
        if (paymentPayload.amount < 1) {
            return AlertManager.error('Impossible de générer un paiement inférieur à 1 €')
        }
        return ApiUser.anonPaymentLink({ id_contract: contract.id }, paymentPayload).$promise.then(() => {
            AlertManager.success(`E-mail ${paymentPayload.mode === 'both' ? 'et sms envoyés' : 'envoyé'}`)
            const comment = `<b>AUTOMATIQUE</b> : lien de paiement CB de <b>${paymentPayload.amount} €</b> envoyé au client par mail${paymentPayload.mode === 'both' ? ' + SMS' : ''}.`
            AdminComments.addComment({ object: contract.id, comment }).$promise.catch(ErrorCatcher)
            return true
        })
        .catch(ErrorCatcher)
    }

    const generatePayment = function (contract, paymentPayload) {
        const payload = angular.copy(paymentPayload)
        payload.payment_date = moment(payload.payment_date).format('YYYY-MM-DD')
        return DataAccess.regularizeBalance({ id_contract: contract.id }, payload).$promise.then((result) => {
            AlertManager.success(result.message)
            MetaWatcher.notif('PAYMENT_CHANGED', contract)
            let comment = `<b>AUTOMATIQUE</b> : `
            _.each(payload.payments, (payment) => {
                const formattedDate = moment(payment.payment_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
                comment += `<br> paiement généré <b>${payment.amount} €</b>, le <b>${formattedDate}</b> à l'initiative ${
                    payload.providerInitiative ? `de <b>${providerLabel}</b>.` : 'du <b>client</b>.'}`
            })
            AdminComments.addComment({ object: contract.id, comment }).$promise.catch(ErrorCatcher)
        }).catch(ErrorCatcher)
    }

    const generateReimbursement = function (contract, paymentPayload) {
        const payload = angular.copy(paymentPayload)
        payload.payment_date = moment(payload.payment_date).format('YYYY-MM-DD')
        return DataAccess.reimburseContract({ id_contract: contract.id }, payload).$promise.then((result) => {
            AlertManager.success(result.message)
            MetaWatcher.notif('PAYMENT_CHANGED', contract)
            const reformat = moment(payload.payment_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
            const comment = `<b>AUTOMATIQUE</b> : remboursement généré <b>${payload.amount} €</b>, le <b>${reformat}</b>`
            return AdminComments.addComment({ object: contract.id, comment }).$promise.catch(ErrorCatcher)
        }).catch(ErrorCatcher)
    }

    const depositBurnPayload = () => ({ amount: 0 })

    const depositBurnFields = () => ({ amount: { label: 'Montant', type: 'number' } })

    const canBurnDeposit = (contract) =>
        BoFeaturesService.isFeatureOn('canBurnDeposit') &&
        (contract.depositBalance > 0) &&
        (contract.contractBalance.balance < 0)

    const energyCheckBurnPayload = () => ({ amount: 0 })

    const energyCheckBurnFields = () => ({ amount: { label: 'Montant', type: 'number' } })

    const canBurnEnergyCheck = (contract, account) => account && contract &&
        BoFeaturesService.isFeatureOn('canBurnEnergyCheck') &&
        (account.energyCheckBalance && account.energyCheckBalance.balance > 0) &&
        (contract.contractBalance.balance < 0)

    const canReimburseDeposit = (contract) =>
        BoFeaturesService.isFeatureOn('canReimburseDeposit') &&
        (contract.depositBalance > 0) &&
        moment(contract.depositDate).isSameOrBefore(moment().add(-1, 'year')) &&
        (contract.contractBalance.balance >= 0)

    const canRefundCbDeposit = (contract) =>
        BoFeaturesService.isFeatureOn('canReimburseDeposit') &&
        (contract.depositBalance > 0) &&
        moment(contract.depositDate).isAfter(moment().add(-1, 'year')) &&
        (contract.contractBalance.balance >= 0)

    const depositBurn = function (contract, depositBurnP, spinners) {
        if (depositBurnP.amount > -contract.contractBalance.balance) {
            return AlertManager.error(`Impossible de transférer un montant supérieur au solde débiteur (${-contract.contractBalance.balance}) €`)
        }
        if (depositBurnP.amount > Number(contract.depositBalance)) {
            return AlertManager.error('Impossible de transférer un montant supérieur au dépôt de garantie')
        }
        const payload = {
            amount: depositBurnP.amount,
        }
        spinners.depositBurning = true
        return DataAccess.depositBurn({ id_contract: contract.id }, payload).$promise.then((burnResult) => {
            AlertManager.success('Transfert effectué')
            const comment = `<b>AUTOMATIQUE</b> : transfert depuis le dépôt de garantie de ${payload.amount} €`
            return AdminComments.addComment({ object: contract.id, comment }).$promise.catch(ErrorCatcher)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            spinners.depositBurning = false
        })
    }

    const energyCheckBurn = (contract, account, energyCheckBurnP, spinners) => {
        if (energyCheckBurnP.amount > -contract.contractBalance.balance) {
            return AlertManager.error(`Impossible de transférer un montant supérieur au solde débiteur (${-contract.contractBalance.balance}) €`)
        }
        if (energyCheckBurnP.amount > Number(account.energyCheckBalance.balance)) {
            return AlertManager.error('Impossible de transférer un montant supérieur au solde de chèque énergie')
        }
        const payload = {
            amount: energyCheckBurnP.amount,
            id_contract: contract.id,
        }
        spinners.energyCheckBurning = true
        return DataAccess.energyCheckBurn(payload).$promise.then((burnResult) => {
            AlertManager.success('Transfert effectué')
            const comment = `<b>AUTOMATIQUE</b> : transfert depuis le solde du chèque énergie de ${payload.amount} €`
            return AdminComments.addComment({ object: contract.id, comment }).$promise.catch(ErrorCatcher)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            spinners.energyCheckBurning = false
        })
    }

    const reimburseDeposit = function (contract) {
        return DataAccess.reimburseDeposit({ id_contract: contract.id }, {}).$promise.then((reimburseResult) => {
            AlertManager.success('Dépôt remboursé')
            const comment = `<b>AUTOMATIQUE</b> : dépôt de garantie remboursé (${-reimburseResult.payment.amount}€) par création d'un virement SEPA`
            return AdminComments.addComment({ object: contract.id, comment }).$promise.catch(ErrorCatcher)
        })
        .catch(ErrorCatcher)
    }

    const refundCbDeposit = function (deposit) {
        deposit.refunding = true
        return DataAccess.refundCbDeposit({ id: deposit.id }, {}).$promise
        .then((reimburseResult) => {
            AlertManager.success('Dépôt remboursé')
            const comment = `<b>AUTOMATIQUE</b> : dépôt de garantie remboursé (${-reimburseResult.payment.amount}€) via le remboursement CB`
            return AdminComments.addComment({ object: reimburseResult.payment.id_contract, comment }).$promise.catch(ErrorCatcher)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            deposit.refunding = false
        })
    }

    const paymentLate = function (payment) {
        return payment.mode === 'SEPA' ? moment(payment.payment_date).isAfter(moment().add(-5, 'days')) : false
    }

    const paymentNotYetValidated = (payment) => {
        return payment && [50, 51, 55].includes(payment.status) && paymentLate(payment)
    }

    // PAYMENT LABEL
    const getSimplePaymentStatus = function (payment) {
        const clientRefusal = payment.rejection_code === 'closed.aborted.aborted_byclient'
        const STATUS_LABEL_MAPPING = {
            0: 'Prévu',
            10: 'Transmis',
            11: 'Attente client',
            40: 'En attente validation',
            50: 'Transmis',
            51: paymentNotYetValidated(payment) ? 'En cours' : 'OK',
            55: paymentNotYetValidated(payment) ? 'En cours' : 'OK',
            70: 'Annulé',
            90: clientRefusal ? 'Annulé client' : 'En erreur',
            91: 'Non présenté',
            93: 'Refusé',
            94: 'Refusé',
            95: 'Refusé',
            96: 'Refusé',
            98: 'OK',
        }
        return _.defaultTo(STATUS_LABEL_MAPPING[payment.status], { label: $filter('paymentStatus')(payment.status) })
    }

    const isPaymentModifyingBalance = (payment, lastInvoiceDate) => {
        return (!payment.invoiced_in_v2 &&
        ((['REC'].includes(payment.type) && payment.status <= 55) ||
        (['TT', 'MISC', 'REG', 'BURN'].includes(payment.type) && payment.status > 55 && (!lastInvoiceDate || moment(payment.invoice_value_date).isAfter(moment(lastInvoiceDate)))))) ||
        (payment.invoiced_in_v2 && payment.status > 55 && !['MISC', 'REG'].includes(payment.type) && moment(payment.rejection_date).isAfter(moment(lastInvoiceDate)))
    }

    const refundCbPayment = (payment, refundPayload) => {
        payment.refunding = true
        const payload = {}
        payload.amount = refundPayload.amount
        return ApiUser.refundCBPayment({ id: payment.id }, payload).$promise.then((result) => {
            AlertManager.success(`Paiement partiellement remouboursé de ${refundPayload.amount} €`)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            payment.refunding = false
        })
    }

    const canRefund = (payment) => {
        return payment.mode === 'CB' &&
            [50, 55].includes(payment.status) &&
            !payment.refunding &&
            payment.amount > 0 &&
            MS.round(_.sum(_.map(_.filter(payment.refunds, (refund) => refund.status <= 55), 'amount')), 2) > -payment.amount
    }

    const refundFields = {
        amount: {
            label: `Montant`,
            type: 'number',
        },
    }

    const generateRefundTemplate = (payment, balance) => {
        const refundable = MS.round(payment.amount + _.sum(_.map(_.filter(payment.refunds, (refund) => refund.status <= 55), 'amount')), 2)
        const amount = Math.min(balance, refundable)
        return {
            amount,
        }
    }

    const fetchSlimpayStatus = (payment) => {
        payment.fetching = true
        const payload = {
            reference: `${payment.id}`,
            external_ref: payment.external_ref,
        }
        let scheme
        switch (payment.mode) {
            case 'CB':
                scheme = 'CARD'
                break
            case 'SEPA':
                if (payment.amount >= 0) {
                    scheme = 'SEPA.DIRECT_DEBIT.CORE'
                } else {
                    scheme = 'SEPA.CREDIT_TRANSFER'
                }
                break
            default: scheme = 'SEPA.DIRECT_DEBIT.CORE'
        }
        if (payment.amount < 0) {
            payload.direction = 'OUT'
        }
        return ApiUser.fetchPaymentBankStatus({ scheme }, payload).$promise.then((result) => {
            AlertManager.success(`Statut du paiement ${payment.id} en banque: "${result.executionStatus}"` +
                `${result.executionDate ? `, date d'execution : "${moment(result.executionDate).format('DD/MM/YYYY')}"` : ''}`)
            console.log(`Retour complet de slimpay du paiement ${payment.id}`, result)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            payment.fetching = false
        })
    }

    return {
        newPaymentPayload,
        newReimbursementPayload,
        newPaymentFields,
        reimbursementFields,
        paymentMailFields,
        paymentMailPayload,
        logPaymentFields,
        logPaymentPayload,
        prepareLogPaymentPayload,
        logPayment,
        validatePayment,
        sendPaymentMail,
        generatePayment,
        generateReimbursement,
        depositBurnPayload,
        depositBurnFields,
        canBurnDeposit,
        canReimburseDeposit,
        canRefundCbDeposit,
        reimburseDeposit,
        refundCbDeposit,
        depositBurn,
        energyCheckBurn,
        getSimplePaymentStatus,
        paymentNotYetValidated,
        syncFields,
        syncSlimpay,
        syncPayload,
        isPaymentModifyingBalance,
        energyCheckBurnPayload,
        energyCheckBurnFields,
        canBurnEnergyCheck,
        refundCbPayment,
        canRefund,
        refundFields,
        generateRefundTemplate,
        fetchSlimpayStatus,
    }
})
